import { ethers } from "ethers";

let currentSigner: ethers.Signer | null = null;

export const setCurrentSigner = (signer: ethers.Signer | null) => {
  currentSigner = signer;
};

export const getCurrentSigner = () => currentSigner;